import { VZ_PERMISSIONS } from "@/helpers/permissionMapper";
const DocMenuConfig = [
  {
    section: "Dashboard",
    fontIcon: "bi bi-columns-gap",
    permissionGroup: "DASHBOARD",
    menus: [
      {
        heading: "Branch Overview",
        route: "/branch-dashboard",
        fontIcon: "bi bi-ui-radios-grid",
        permission: VZ_PERMISSIONS.DASHBOARD_SITESOVERVIEW,
      },
      {
        heading: "Performance Review",
        route: "/form-dashboard",
        fontIcon: "bi bi-speedometer",
        permission: VZ_PERMISSIONS.DASHBOARD_PERFORMANCEREVIEW,
      },
      {
        heading: "User Statistics",
        route: "/user-dashboard",
        fontIcon: "bi bi-person-video2",
        permission: VZ_PERMISSIONS.DASHBOARD_USERSTATISTICS,
      },
    ],
  },
  {
    section: "Business",
    fontIcon: "bi bi-globe2",
    permissionGroup: "BUSINESS",
    menus: [
      {
        heading: "Client",
        route: "/client",
        fontIcon: "las la-user-tie",
        permission: VZ_PERMISSIONS.BUSINESS_CLIENT,
      },
      {
        heading: "Branches",
        route: "/branch",
        fontIcon: "bi bi-diagram-3",
        permission: VZ_PERMISSIONS.BUSINESS_SITE,
      },
      {
        heading: "Locations",
        route: "/locations",
        fontIcon: "bi bi-geo-alt",
        permission: VZ_PERMISSIONS.BUSINESS_LOCATIONS,
      },
    ],
  },
  {
    section: "Applications",
    fontIcon: "bi bi-app-indicator",
    permissionGroup: "APPLICATIONS",
    menus: [
      {
        heading: "Scheduler",
        route: "/scheduler",
        fontIcon: "las la-calendar-alt",
        permission: VZ_PERMISSIONS.APPLICATIONS_SCHEDULER,
      },
      {
        heading: "Email",
        route: "/email/details",
        fontIcon: "las la-mail-bulk",
        permission: VZ_PERMISSIONS.APPLICATIONS_EMAIL,
      },
      {
        heading: "Chat",
        route: "/chat",
        fontIcon: "las la-sms",
        permission: VZ_PERMISSIONS.APPLICATIONS_SMS,
      },
    ],
  },
  {
    section: "Templates",
    fontIcon: "bi bi-layout-text-window-reverse",
    permissionGroup: "TEMPLATES",
    menus: [
      {
        heading: "Tasks",
        route: "/documents",
        fontIcon: "las la-file-alt",
        permission: VZ_PERMISSIONS.TEMPLATES_TASKS,
      },
      {
        heading: "Forms",
        route: "/form",
        fontIcon: "bi bi-layers",
        permission: VZ_PERMISSIONS.TEMPLATES_FORMS,
      },
      {
        heading: "Sections",
        route: "/sections",
        fontIcon: "bi bi-list-stars",
        permission: VZ_PERMISSIONS.TEMPLATES_SECTIONS,
      },
    ],
  },
  {
    section: "Users",
    fontIcon: "bi bi-people",
    permissionGroup: "USERS",
    menus: [
      {
        heading: "Users",
        route: "/user",
        fontIcon: "bi bi-people",
        permission: VZ_PERMISSIONS.USERS_USERS,
      },
      {
        heading: "Roles",
        route: "/roles",
        fontIcon: "bi bi-person-check",
        permission: VZ_PERMISSIONS.USERS_ROLES,
      },
      {
        heading: "Permissions",
        route: "/permissions",
        fontIcon: "las la-check-circle",
        permission: VZ_PERMISSIONS.USERS_PERMISSIONS,
      },
      {
        heading: "User Permissions",
        route: "/user-permission",
        fontIcon: "las la-user-lock",
        permission: VZ_PERMISSIONS.USERS_USERPERMISSIONS,
      },
    ],
  },
  {
    section: "Settings",
    fontIcon: "bi bi-sliders",
    permissionGroup: "SETTINGS",
    menus: [
      {
        heading: "Lookup Configuration",
        route: "/lookup",
        fontIcon: "las la-door-open",
        permission: VZ_PERMISSIONS.SETTINGS_LOOKUPCONFIGURATION,
      },
      {
        heading: "Events",
        route: "/eventManagement",
        fontIcon: "las la-business-time",
        permission: VZ_PERMISSIONS.SETTINGS_EVENTS,
      },
    ],
  },
  {
    section: "Integrations",
    fontIcon: "bi bi-link-45deg",
    permissionGroup: "INTEGRATIONS",
    menus: [
      {
        heading: "Email Configuration",
        route: "/email",
        fontIcon: "las la-envelope",
        permission: VZ_PERMISSIONS.INTEGRATIONS_EMAILMANAGER,
      },
      {
        heading: "Devices",
        route: "/devices",
        fontIcon: "bi bi-cpu",
        permission: VZ_PERMISSIONS.INTEGRATIONS_DEVICES,
      },
      {
        heading: "SMS Configuration",
        route: "/smsConfig",
        fontIcon: "las la-sms",
        permission: VZ_PERMISSIONS.INTEGRATIONS_SMSMANAGER,
      },
    ],
  },
];
export default DocMenuConfig;
